module.exports = __webpack_public_path__ + "assets/compensation.0d997295.svg";